<template>
	<div class="home-preview">



		<!-- 关于我们 -->
		<div id="about" class="animate__animated">
			<div class="about_item">
				<div class="about_title_box">
					<div class="about_title">{{aboutUsDetail.title}}</div>
					<div class="about_subtitle">{{aboutUsDetail.subtitle}}</div>
				</div>
				<div class="about_img">
					<img :src="baseUrl + aboutUsDetail.picture1">
					<img :src="baseUrl + aboutUsDetail.picture2">
					<img :src="baseUrl + aboutUsDetail.picture3">
				</div>
				<div class="about_content ql-snow ql-editor" v-html="aboutUsDetail.content"></div>
				<div class="about_idea1" />
				<div class="about_idea2" />
				<div class="about_idea3" />
				<div class="about_idea4" />
				<div class="about_more" @click="toDetail('aboutusDetail',aboutUsDetail)">
					<span>更多</span>
					<span class="icon iconfont icon-gengduo1"></span>
				</div>
			</div>
		</div>
		<!-- 关于我们 -->

		<!-- 商品推荐 -->
		<div id="animate_recommendyisheng" class="recommend animate__animated">
			<div class="recommend_title_box">
				<span class="recommend_title">医生推荐</span>
				<span class="recommend_subhead">{{'yisheng'.toUpperCase()}} RECOMMEND</span>
			</div>
			<div class="list list20 index-pv1">
				<div class="list-body">
					<div class="list-item" v-for="(item,index) in yishengRecommend" :key="index" @click="toDetail('yishengDetail', item)">
						<div class="img">
							<img v-if="preHttp(item.touxiang)" :src="item.touxiang.split(',')[0]" alt="" />
							<img v-else :src="baseUrl + (item.touxiang?item.touxiang.split(',')[0]:'')" alt="" />
						</div>
						<div class="infoBox">
							<div class="name">{{item.yishengxingming}}</div>
							<div class="name">职称:{{item.zhicheng}}</div>
							<div class="time_item">
								<span class="icon iconfont icon-shijian21"></span>
								<span class="label">发布时间：</span>
								<span class="text">{{item.addtime}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="moreBtn" @click="moreBtn('yisheng')">
				<span class="text">查看更多</span>
				<i class="icon iconfont icon-gengduo1"></i>
			</div>
		</div>
		<!-- 商品推荐 -->
		<!-- 商品推荐 -->
		<div id="animate_recommendyaofangxinxi" class="recommend animate__animated">
			<div class="recommend_title_box">
				<span class="recommend_title">药方信息推荐</span>
				<span class="recommend_subhead">{{'yaofangxinxi'.toUpperCase()}} RECOMMEND</span>
			</div>
			<div class="list list20 index-pv1">
				<div class="list-body">
					<div class="list-item" v-for="(item,index) in yaofangxinxiRecommend" :key="index" @click="toDetail('yaofangxinxiDetail', item)">
						<div class="img">
							<img v-if="preHttp(item.yaofangtupian)" :src="item.yaofangtupian.split(',')[0]" alt="" />
							<img v-else :src="baseUrl + (item.yaofangtupian?item.yaofangtupian.split(',')[0]:'')" alt="" />
						</div>
						<div class="infoBox">
							<div class="name">{{item.yaofangmingcheng}}</div>
							<div class="time_item">
								<span class="icon iconfont icon-shijian21"></span>
								<span class="label">发布时间：</span>
								<span class="text">{{item.addtime}}</span>
							</div>
							<div class="publisher_item">
								<span class="icon iconfont icon-geren16"></span>
								<span class="label">发布人：</span>
								<span class="text">{{item.yishenggonghao}}</span>
							</div>
							<div class="like_item">
								<span class="icon iconfont icon-zan10"></span>
								<span class="label">点赞数：</span>
								<span class="text">{{item.thumbsupnum}}</span>
							</div>
							<div class="collect_item">
								<span class="icon iconfont icon-shoucang10"></span>
								<span class="label">收藏量：</span>
								<span class="text">{{item.storeupnum}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="moreBtn" @click="moreBtn('yaofangxinxi')">
				<span class="text">查看更多</span>
				<i class="icon iconfont icon-gengduo1"></i>
			</div>
		</div>
		<!-- 商品推荐 -->
		<!-- 商品推荐 -->
		<div id="animate_recommendyaopinxinxi" class="recommend animate__animated">
			<div class="recommend_title_box">
				<span class="recommend_title">药品信息推荐</span>
				<span class="recommend_subhead">{{'yaopinxinxi'.toUpperCase()}} RECOMMEND</span>
			</div>
			<div class="list list20 index-pv1">
				<div class="list-body">
					<div class="list-item" v-for="(item,index) in yaopinxinxiRecommend" :key="index" @click="toDetail('yaopinxinxiDetail', item)">
						<div class="img">
							<img v-if="preHttp(item.yaopintupian)" :src="item.yaopintupian.split(',')[0]" alt="" />
							<img v-else :src="baseUrl + (item.yaopintupian?item.yaopintupian.split(',')[0]:'')" alt="" />
						</div>
						<div class="infoBox">
							<div class="name">{{item.yaopinmingcheng}}</div>
							<div class="price">￥{{item.price}}</div>
							<div class="time_item">
								<span class="icon iconfont icon-shijian21"></span>
								<span class="label">发布时间：</span>
								<span class="text">{{item.addtime}}</span>
							</div>
							<div class="collect_item">
								<span class="icon iconfont icon-shoucang10"></span>
								<span class="label">收藏量：</span>
								<span class="text">{{item.storeupnum}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="moreBtn" @click="moreBtn('yaopinxinxi')">
				<span class="text">查看更多</span>
				<i class="icon iconfont icon-gengduo1"></i>
			</div>
		</div>
		<!-- 商品推荐 -->
		<!-- 特价商品 -->
		<div id="animate_listzhongyizhishi" class="lists animate__animated">
			<div class="list_title_box">
				<span class="list_title">中医知识展示</span>
				<span class="list_subhead">{{'zhongyizhishi'.toUpperCase()}} SHOW</span>
			</div>
			<div class="list list15 index-pv1">
				<div class="list-body-left">
					<template v-if="zhongyizhishiList.length">
						<template v-for="item,index in zhongyizhishiList">
							<div v-if="index == 0" @click="toDetail('zhongyizhishiDetail', item)" class="box1 list-item">
								<img :name="item.id" v-if="preHttp(item.fengmian)" :src="item.fengmian.split(',')[0]" alt="" />
								<img :name="item.id" v-else :src="baseUrl + (item.fengmian?item.fengmian.split(',')[0]:'')" alt="" />
								<div class="infoBox">
									<div class="name">{{item.zhishibiaoti}}</div>
									<div class="name">{{item.zhishileixing}}</div>
								</div>
							</div>
						</template>
					</template>
					<template v-if="zhongyizhishiList.length > 1">
						<template v-for="item,index in zhongyizhishiList">
							<div v-if="index == 1" @click="toDetail('zhongyizhishiDetail', item)" class="box2 list-item">
								<img :name="item.id" v-if="preHttp(item.fengmian)" :src="item.fengmian.split(',')[0]" alt="" />
								<img :name="item.id" v-else :src="baseUrl + (item.fengmian?item.fengmian.split(',')[0]:'')" alt="" />
								<div class="infoBox">
									<div class="name">{{item.zhishibiaoti}}</div>
									<div class="name">{{item.zhishileixing}}</div>
								</div>
							</div>
						</template>
					</template>
				</div>
				<div class="list-body-center">
					<template v-if="zhongyizhishiList.length > 2">
						<template v-for="item,index in zhongyizhishiList">
							<div v-if="index == 2" @click="toDetail('zhongyizhishiDetail', item)" class="box1 list-item">
								<img :name="item.id" v-if="preHttp(item.fengmian)" :src="item.fengmian.split(',')[0]" alt="" />
								<img :name="item.id" v-else :src="baseUrl + (item.fengmian?item.fengmian.split(',')[0]:'')" alt="" />
								<div class="infoBox">
									<div class="name">{{item.zhishibiaoti}}</div>
									<div class="name">{{item.zhishileixing}}</div>
								</div>
							</div>
						</template>
					</template>
					<div class="box2">
						<div class="name">{{zhongyizhishiList[2].zhishibiaoti}}</div>
						<div class="desc ql-snow ql-editor" v-html="zhongyizhishiList[2].jiankangjianyi"></div>
					</div>
					<template v-if="zhongyizhishiList.length > 3">
						<template v-for="item,index in zhongyizhishiList">
							<div v-if="index == 3" @click="toDetail('zhongyizhishiDetail', item)" class="box3 list-item">
								<img :name="item.id" v-if="preHttp(item.fengmian)" :src="item.fengmian.split(',')[0]" alt="" />
								<img :name="item.id" v-else :src="baseUrl + (item.fengmian?item.fengmian.split(',')[0]:'')" alt="" />
								<div class="infoBox">
									<div class="name">{{item.zhishibiaoti}}</div>
									<div class="name">{{item.zhishileixing}}</div>
								</div>
							</div>
						</template>
					</template>
				</div>
				<div class="list-body-right">
					<template v-if="zhongyizhishiList.length > 4">
						<template v-for="item,index in zhongyizhishiList">
							<div v-if="index == 4" @click="toDetail('zhongyizhishiDetail', item)" class="box1 list-item">
								<img :name="item.id" v-if="preHttp(item.fengmian)" :src="item.fengmian.split(',')[0]" alt="" />
								<img :name="item.id" v-else :src="baseUrl + (item.fengmian?item.fengmian.split(',')[0]:'')" alt="" />
								<div class="infoBox">
									<div class="name">{{item.zhishibiaoti}}</div>
									<div class="name">{{item.zhishileixing}}</div>
								</div>
							</div>
						</template>
					</template>
					<template v-if="zhongyizhishiList.length > 5">
						<template v-for="item,index in zhongyizhishiList">
							<div v-if="index == 5" @click="toDetail('zhongyizhishiDetail', item)" class="box2 list-item">
								<img :name="item.id" v-if="preHttp(item.fengmian)" :src="item.fengmian.split(',')[0]" alt="" />
								<img :name="item.id" v-else :src="baseUrl + (item.fengmian?item.fengmian.split(',')[0]:'')" alt="" />
								<div class="infoBox">
									<div class="name">{{item.zhishibiaoti}}</div>
									<div class="name">{{item.zhishileixing}}</div>
								</div>
							</div>
						</template>
					</template>
				</div>
			</div>
			<div class="moreBtn" @click="moreBtn('zhongyizhishi')">
				<span class="text">查看更多</span>
				<i class="icon iconfont icon-gengduo1"></i>
			</div>
	

		</div>
		<!-- 特价商品 -->
	</div>
</template>

<script>
import 'animate.css'
import Swiper from "swiper";

	export default {
		//数据集合
		data() {
			return {
				baseUrl: '',
				aboutUsDetail: {},
				newsList: [],
				yishengRecommend: [],
				yaofangxinxiRecommend: [],
				yaopinxinxiRecommend: [],

				zhongyizhishiList: [],




			}
		},
		created() {
			this.baseUrl = this.$config.baseUrl;
			this.getAboutUs();
			this.getList();
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll)
			setTimeout(()=>{
				this.handleScroll()
			},100)
			
			this.swiperChanges()
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll)
		},
		//方法集合
		methods: {
			swiperChanges() {
				setTimeout(()=>{
				},750)
			},
			newsTabClick23(index) {
				this.newsIndex23 = index
			},


			handleScroll() {
				let arr = [
					{id:'about',css:'animate__'},
					{id:'system',css:'animate__'},
					{id:'animate_recommendyisheng',css:'animate__'},
					{id:'animate_recommendyaofangxinxi',css:'animate__'},
					{id:'animate_recommendyaopinxinxi',css:'animate__'},
					{id:'animate_listzhongyizhishi',css:'animate__'},
				]
			
				for (let i in arr) {
					let doc = document.getElementById(arr[i].id)
					if (doc) {
						let top = doc.offsetTop
						let win_top = window.innerHeight + window.pageYOffset
						// console.log(top,win_top)
						if (win_top > top && doc.classList.value.indexOf(arr[i].css) < 0) {
							// console.log(doc)
							doc.classList.add(arr[i].css)
						}
					}
				}
			},
			preHttp(str) {
				return str && str.substr(0,4)=='http';
			},
			preHttp2(str) {
				return str && str.split(',w').length>1;
			},
			getAboutUs() {
				this.$http.get('aboutus/detail/1', {}).then(res => {
					if(res.data.code == 0) {
						this.aboutUsDetail = res.data.data;
					}
				})
			},
			getList() {
				let autoSortUrl = "";
				let data = {}
				autoSortUrl = "yisheng/autoSort";
				data = {
					page: 1,
					limit: 8,
				}
				this.$http.get(autoSortUrl, {params: data}).then(res => {
					if (res.data.code == 0) {
						this.yishengRecommend = res.data.data.list;
					}
				});
				autoSortUrl = "yaofangxinxi/autoSort";
				if(localStorage.getItem('frontToken')) {
					autoSortUrl = "yaofangxinxi/autoSort2";
				}
				data = {
					page: 1,
					limit: 8,
				}
				this.$http.get(autoSortUrl, {params: data}).then(res => {
					if (res.data.code == 0) {
						this.yaofangxinxiRecommend = res.data.data.list;
					}
				});
				autoSortUrl = "yaopinxinxi/autoSort";
				if(localStorage.getItem('frontToken')) {
					autoSortUrl = "yaopinxinxi/autoSort2";
				}
				data = {
					page: 1,
					limit: 8,
					onshelves: 1,
				}
				this.$http.get(autoSortUrl, {params: data}).then(res => {
					if (res.data.code == 0) {
						this.yaopinxinxiRecommend = res.data.data.list;
					}
				});
			
				data = {
					page: 1,
					limit: 6,
				}

				this.$http.get('zhongyizhishi/list', {params: data}).then(res => {
					if (res.data.code == 0) {
						this.zhongyizhishiList = res.data.data.list;
					}
				});
			},
			toDetail(path, item) {
				this.$router.push({path: '/index/' + path, query: {id: item.id}});
			},
			moreBtn(path) {
				this.$router.push({path: '/index/' + path});
			}
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	.home-preview {
		padding: 0;
		margin: 0 auto;
		flex-direction: column;
		background: #F4F4F4;
		display: flex;
		width: 100%;
		#about {
			padding: 30px calc(50% - 650px);
			margin: 0;
			overflow: hidden;
			background: #F0F0F0;
			width: 100%;
			position: relative;
			order: 2;
			height: auto;
			.about_item {
				padding: 0;
				display: flex;
				width: 100%;
				position: relative;
				flex-wrap: wrap;
				.about_title_box {
					padding: 0;
					margin: 0 0 20px 0;
					color: #000;
					background: none;
					font-weight: 600;
					letter-spacing: 1px;
					width: 100%;
					font-size: 24px;
					line-height: 70px;
					text-align: center;
					.about_title {
						padding: 0 4px 0px 4px;
						color: inherit;
						font-weight: 600;
						display: inline-block;
						font-size: 24px;
						border-color: #37A679;
						border-width: 0 0 2px 0;
						border-style: solid;
					}
					.about_subtitle {
						margin: 0 0 10px;
						color: #999;
						display: none;
						width: 100%;
						font-size: 20px;
						line-height: 1.5;
						text-align: center;
					}
				}
				.about_img {
					border: none;
					padding: 0;
					grid-template-columns: 1fr 1fr;
					grid-template-rows: 1fr 1fr;
					display: grid;
					gap: 20px;
					width: 560px;
					height: 400px;
					img:nth-child(1) {
						grid-row: 1 / 2;
						border-radius: 10px;
						margin: 0;
						object-fit: cover;
						display: block;
						width: 270px;
						grid-column: 1 / 2;
						height: 190px;
					}
					img:nth-child(2) {
						grid-row: 1 / 3;
						border-radius: 10px;
						margin: 0;
						object-fit: cover;
						display: block;
						width: 100%;
						grid-column: 2 / 3;
						height: 400px;
					}
					img:nth-child(3) {
						grid-row: 2 / 3;
						border-radius: 10px;
						margin: 0;
						object-fit: cover;
						display: block;
						width: 100%;
						grid-column: 1 / 2;
						height: 190px;
					}
				}
				.about_content {
					padding: 50px;
					margin: 0 0 0 30px;
					color: #000;
					display: flex;
					letter-spacing: 1px;
					font-size: 16px;
					border-radius: 10px;
					overflow: hidden;
					background: #FFFFFF;
					flex: auto;
					width: 0;
					justify-content: flex-start;
					align-items: flex-start;
					height: auto;
				}
				.about_idea1 {
					background: url(http://codegen.caihongy.cn/20201114/7856ba26477849ea828f481fa2773a95.jpg) 0% 0% / cover no-repeat;
					display: none;
					width: 285px;
					height: 100px;
				}
				.about_idea2 {
					background: url(http://codegen.caihongy.cn/20201114/7856ba26477849ea828f481fa2773a95.jpg) 0% 0% / cover no-repeat;
					display: none;
					width: 285px;
					height: 100px;
				}
				.about_idea3 {
					background: url(http://codegen.caihongy.cn/20201114/7856ba26477849ea828f481fa2773a95.jpg) 0% 0% / cover no-repeat;
					display: none;
					width: 285px;
					height: 100px;
				}
				.about_idea4 {
					background: url(http://codegen.caihongy.cn/20201114/7856ba26477849ea828f481fa2773a95.jpg) 0% 0% / cover no-repeat;
					display: none;
					width: 285px;
					height: 100px;
				}
				.about_more {
					border: 0;
					cursor: pointer;
					margin: 0;
					top: 0;
					background: #fff;
					display: none;
					width: 80px;
					line-height: 32px;
					position: absolute;
					right: 0;
					text-align: center;
					span:nth-child(1) {
						color: #0E667D;
						font-size: 12px;
					}
					span:nth-child(2) {
						color: #0E667D;
						font-size: 12px;
					}
				}
				.about_more:hover {
					opacity: 0.9;
				}
			}
		}
		.recommend {
			padding: 30px calc(50% - 650px);
			margin: 0 auto;
			background: #fff;
			width: 100%;
			position: relative;
			order: 4;
			.recommend_title_box {
				padding: 0;
				margin: 0;
				color: #fff;
				background: none;
				flex: none;
				font-weight: 600;
				width: 100%;
				font-size: 24px;
				line-height: 40px;
				text-align: center;
				height: auto;
				.recommend_title {
					color: #000000;
					font-weight: 600;
					font-size: 24px;
				}
				.recommend_subhead {
					margin: 0 0 10px;
					color: #999;
					display: block;
					width: 100%;
					font-size: 20px;
					line-height: 1.5;
					text-align: center;
				}
			}
			.index-pv1 .animation-box {
				transform: rotate(0deg) scale(1) skew(0deg, 0deg) translate3d(0px, 0px, 0px);
				z-index: initial;
			}
			
			.index-pv1 .animation-box:hover {
				transform: rotate(0deg) scale(1) skew(0deg, 0deg) translate3d(0px, 10px, 0px);
				-webkit-perspective: 1000px;
				perspective: 1000px;
				transition: 0.3s;
				z-index: 1;
			}
			
			.index-pv1 .animation-box img {
				transform: rotate(0deg) scale(1) skew(0deg, 0deg) translate3d(0px, 0px, 0px);
			}
			
			.index-pv1 .animation-box img:hover {
				transform: rotate(0deg) scale(1) skew(0deg, 0deg) translate3d(0px, 0px, 0px);
				-webkit-perspective: 1000px;
				perspective: 1000px;
				transition: 0.3s;
			}
			.list20 {
				margin: 0 auto;
				overflow: hidden;
				background: none;
				width: 100%;
				clear: both;
				.list-body {
					margin: 0 auto;
					display: flex;
					width: 100%;
					justify-content: space-between;
					position: relative;
					flex-wrap: wrap;
					.list-item {
						border: 10px solid #fff;
						margin: 0 0 15px;
						z-index: 99;
						overflow: hidden;
						width: calc(25% - 10px);
						position: relative;
						height: 300px;
						.img {
							border: 10px solid #fff;
							width: 100%;
							height: 100%;
							img {
								object-fit: cover;
								width: 100%;
								height: 100%;
							}
						}
						.infoBox {
							padding: 10px 0px;
							bottom: -100%;
							display: flex;
							transition: all 0.5s;
							flex-wrap: wrap;
							flex-direction: column;
							left: 0px;
							background: rgba(255, 255, 255, .8);
							width: 100%;
							justify-content: center;
							align-items: center;
							position: absolute;
							text-align: center;
							.name {
								padding: 0px 10px;
								overflow: hidden;
								color: #fff;
								white-space: nowrap;
								display: block;
								font-size: 16px;
								text-overflow: ellipsis;
							}
							.price {
								padding: 0px 10px;
								color: #f00;
								font-size: 16px;
							}
							.time_item {
								padding: 0;
								.icon {
									margin: 0 2px 0 0;
									color: #fff;
									font-size: 12px;
									line-height: 1.5;
								}
								.label {
									color: #fff;
									font-size: 12px;
									line-height: 1.5;
								}
								.text {
									color: #fff;
									font-size: 12px;
									line-height: 1.5;
								}
							}
							.publisher_item {
								padding: 0;
								.icon {
									margin: 0 2px 0 0;
									color: #fff;
									font-size: 12px;
									line-height: 1.5;
								}
								.label {
									color: #fff;
									font-size: 12px;
									line-height: 1.5;
								}
								.text {
									color: #fff;
									font-size: 12px;
									line-height: 1.5;
								}
							}
							.like_item {
								padding: 0;
								.icon {
									margin: 0 2px 0 0;
									color: #fff;
									font-size: 12px;
									line-height: 1.5;
								}
								.label {
									color: #fff;
									font-size: 12px;
									line-height: 1.5;
								}
								.text {
									color: #fff;
									font-size: 12px;
									line-height: 1.5;
								}
							}
							.collect_item {
								padding: 0;
								.icon {
									margin: 0 2px 0 0;
									color: #fff;
									font-size: 12px;
									line-height: 1.5;
								}
								.label {
									color: #fff;
									font-size: 12px;
									line-height: 1.5;
								}
								.text {
									color: #fff;
									font-size: 12px;
									line-height: 1.5;
								}
							}
							.view_item {
								padding: 0;
								.icon {
									margin: 0 2px 0 0;
									color: #fff;
									font-size: 12px;
									line-height: 1.5;
								}
								.label {
									color: #fff;
									font-size: 12px;
									line-height: 1.5;
								}
								.text {
									color: #fff;
									font-size: 12px;
									line-height: 1.5;
								}
							}
						}
					}
					.list-item:hover {
						border: 10px solid #339933;
						.img {
							border: 10px solid #68bf68;
							img {
								transform: scale(0.96);
								transition: all 0.5s ease-out;
							}
						}
						.infoBox {
							bottom: 0px;
							background: rgba(0, 0, 0, .5);
							height: 100%;
						}
					}
				}
			}
			.moreBtn {
				border: 0;
				cursor: pointer;
				margin: 0 auto;
				color: #fff;
				background: #37A679;
				display: block;
				width: 150px;
				font-size: 16px;
				line-height: 70px;
				text-align: center;
				height: 70px;
				.text {
					color: inherit;
					font-size: inherit;
				}
				.icon {
					color: inherit;
					font-size: inherit;
				}
			}
		}
		.lists {
			padding: 30px calc(50% - 650px) ;
			margin: 0 auto;
			background: url(http://codegen.caihongy.cn/20250220/6d6a332bdce14472b1e9fe6dde44084d.png) no-repeat center / 100% 100%;
			display: flex;
			width: 100%;
			position: relative;
			flex-wrap: wrap;
			order: 3;
			.list_title_box {
				padding: 0;
				margin: 0;
				color: #fff;
				background: none;
				flex: none;
				font-weight: 600;
				width: 100%;
				font-size: 24px;
				line-height: 80px;
				text-align: center;
				height: 80px;
				.list_title {
					color: inherit;
					font-weight: 600;
					font-size: inherit;
				}
				.list_subhead {
					margin: 0 0 10px;
					color: #999;
					display: none;
					width: 100%;
					font-size: 20px;
					line-height: 1.5;
					text-align: center;
				}
			}
			.index-pv1 .animation-box {
				transform: rotate(0deg) scale(1) skew(0deg, 0deg) translate3d(0px, 0px, 0px);
				z-index: initial;
			}
			
			.index-pv1 .animation-box:hover {
				transform: rotate(0deg) scale(1) skew(0deg, 0deg) translate3d(0px, 0px, 0px);
				-webkit-perspective: 1000px;
				perspective: 1000px;
				transition: 0.3s;
				z-index: 1;
			}
			
			.index-pv1 .animation-box img {
				transform: rotate(0deg) scale(1) skew(0deg, 0deg) translate3d(0px, 0px, 0px);
			}
			
			.index-pv1 .animation-box img:hover {
				transform: rotate(0deg) scale(1) skew(0deg, 0deg) translate3d(0px, 0px, 0px);
				-webkit-perspective: 1000px;
				perspective: 1000px;
				transition: 0.3s;
			}
			.list15 {
				padding: 10px;
				flex: auto;
				display: flex;
				width: 0;
				justify-content: center;
				align-items: center;
				height: auto;
				.list-body-left {
					width: 32%;
					height: auto;
					.box1 {
						border: 1px solid transparent;
						margin: 10px 0;
						overflow: hidden;
						background: #fff;
						width: 100%;
						position: relative;
						transition: all .3s;
						height: auto;
						img {
							object-fit: cover;
							display: block;
							width: 100% ;
							transition: all .3s;
							height: 180px;
						}
						.infoBox {
							left: 0;
							background: rgba(0,0,0,.3);
							bottom: 0;
							display: flex;
							width: 100%;
							justify-content: center;
							align-items: center;
							position: absolute;
							opacity: 0;
							transition: all .3s;
							height: 100%;
							.name {
								color: #fff;
								font-size: 24px;
								line-height: 54px;
							}
							.price {
								padding: 10px;
								color: #f00;
								font-size: 13px;
								line-height: 1.5;
							}
						}
					}
					.box1:hover {
						border: 1px solid #ff0;
						img {
							transform: scale(1.2);
						}
						.infoBox {
							opacity: 1;
						}
					}
					.box2 {
						border: 1px solid transparent;
						margin: 10px 0;
						overflow: hidden;
						background: #fff;
						width: 100%;
						position: relative;
						transition: all .3s;
						height: auto;
						img {
							object-fit: cover;
							display: block;
							width: 100% ;
							transition: all .3s;
							height: 180px;
						}
						.infoBox {
							left: 0;
							background: rgba(0,0,0,.3);
							bottom: 0;
							display: flex;
							width: 100%;
							justify-content: center;
							align-items: center;
							position: absolute;
							opacity: 0;
							transition: all .3s;
							height: 100%;
							.name {
								color: #fff;
								font-size: 24px;
								line-height: 54px;
							}
							.price {
								padding: 10px;
								color: #f00;
								font-size: 13px;
								line-height: 1.5;
							}
						}
					}
					.box2:hover {
						border: 1px solid #ff0;
						img {
							transform: scale(1.2);
						}
						.infoBox {
							opacity: 1;
						}
					}
				}
				.list-body-center {
					margin: 0 2%;
					width: 32%;
					height: auto;
					.box1 {
						border: 1px solid transparent;
						margin: 10px 0;
						overflow: hidden;
						background: #fff;
						width: 100%;
						position: relative;
						transition: all .3s;
						height: auto;
						img {
							object-fit: cover;
							display: block;
							width: 100% ;
							transition: all .3s;
							height: 180px;
						}
						.infoBox {
							left: 0;
							background: rgba(0,0,0,.3);
							bottom: 0;
							display: flex;
							width: 100%;
							justify-content: center;
							align-items: center;
							position: absolute;
							opacity: 0;
							transition: all .3s;
							height: 100%;
							.name {
								color: #fff;
								font-size: 24px;
								line-height: 54px;
							}
							.price {
								padding: 10px;
								color: #f00;
								font-size: 13px;
								line-height: 1.5;
							}
						}
					}
					.box1:hover {
						border: 1px solid #ff0;
						img {
							transform: scale(1.2);
						}
						.infoBox {
							opacity: 1;
						}
					}
					.box2 {
						margin: 10px 0;
						flex-direction: column;
						background: #37A679;
						display: flex;
						width: 100%;
						justify-content: center;
						align-items: center;
						height: 180px;
						.name {
							color: #fff;
							font-size: 24px;
							line-height: 24px;
						}
						.price {
							padding: 10px;
							color: #fff;
							font-size: 13px;
							line-height: 1.5;
						}
						.desc {
							overflow: hidden;
							color: #fff;
							font-size: 16px;
							line-height: 20px;
							height: auto;
						}
					}
					.box3 {
						border: 1px solid transparent;
						margin: 10px 0;
						overflow: hidden;
						background: #fff;
						width: 100%;
						position: relative;
						transition: all .3s;
						height: auto;
						img {
							object-fit: cover;
							display: block;
							width: 100% ;
							transition: all .3s;
							height: 180px;
						}
						.infoBox {
							left: 0;
							background: rgba(0,0,0,.3);
							bottom: 0;
							display: flex;
							width: 100%;
							justify-content: center;
							align-items: center;
							position: absolute;
							opacity: 0;
							transition: all .3s;
							height: 100%;
							.name {
								color: #fff;
								font-size: 24px;
								line-height: 54px;
							}
							.price {
								padding: 10px;
								color: #f00;
								font-size: 13px;
								line-height: 1.5;
							}
						}
					}
					.box3:hover {
						border: 1px solid #ff0;
						img {
							transform: scale(1.2);
						}
						.infoBox {
							opacity: 1;
						}
					}
				}
				.list-body-right {
					width: 32%;
					height: auto;
					.box1 {
						border: 1px solid transparent;
						margin: 10px 0;
						overflow: hidden;
						background: #fff;
						width: 100%;
						position: relative;
						transition: all .3s;
						height: auto;
						img {
							object-fit: cover;
							display: block;
							width: 100% ;
							transition: all .3s;
							height: 180px;
						}
						.infoBox {
							left: 0;
							background: rgba(0,0,0,.3);
							bottom: 0;
							display: flex;
							width: 100%;
							justify-content: center;
							align-items: center;
							position: absolute;
							opacity: 0;
							transition: all .3s;
							height: 100%;
							.name {
								color: #fff;
								font-size: 24px;
								line-height: 54px;
							}
							.price {
								padding: 10px;
								color: #f00;
								font-size: 13px;
								line-height: 1.5;
							}
						}
					}
					.box1:hover {
						border: 1px solid #ff0;
						img {
							transform: scale(1.2);
						}
						.infoBox {
							opacity: 1;
						}
					}
					.box2 {
						border: 1px solid transparent;
						margin: 10px 0;
						overflow: hidden;
						background: #fff;
						width: 100%;
						position: relative;
						transition: all .3s;
						height: auto;
						img {
							object-fit: cover;
							display: block;
							width: 100% ;
							transition: all .3s;
							height: 180px;
						}
						.infoBox {
							left: 0;
							background: rgba(0,0,0,.3);
							bottom: 0;
							display: flex;
							width: 100%;
							justify-content: center;
							align-items: center;
							position: absolute;
							opacity: 0;
							transition: all .3s;
							height: 100%;
							.name {
								color: #fff;
								font-size: 24px;
								line-height: 54px;
							}
							.price {
								padding: 10px;
								color: #f00;
								font-size: 13px;
								line-height: 1.5;
							}
						}
					}
					.box2:hover {
						border: 1px solid #ff0;
						img {
							transform: scale(1.2);
						}
						.infoBox {
							opacity: 1;
						}
					}
				}
			}
			.moreBtn {
				border: 0;
				cursor: pointer;
				margin: 0;
				color: #fff;
				display: flex;
				font-size: 16px;
				line-height: 70px;
				background: #37A679;
				width: 240px;
				justify-content: center;
				align-items: center;
				text-align: center;
				height: 680px;
				.text {
					color: inherit;
					font-size: inherit;
				}
				.icon {
					color: inherit;
					font-size: inherit;
				}
			}
		}
	}
</style>
